<footer class="w3-border w3-cell-row w3-mobile w3-theme-l3 w3-border-theme w3-round">
  <div class="w3-half w3-padding w3-responsive w3-mobile fullheight">
    <omnipas-fonttoggle *ngIf="environment.getEnvValue('togglefont')"></omnipas-fonttoggle>
  </div>
  <div *ngIf="router.transparams.customer_shortname != ''" class="w3-half w3-right-align w3-padding w3-responsive w3-mobile">
    <a class="link" (click)="showAbout()" title="{{ 'header.about' | translate: router.transparams }}">{{ 'header.about' | translate: router.transparams }}</a>
    <br/>
    <span *ngIf="environment.getEnvValue('versioninfooter')" class="w3-text-theme">{{version}}-{{hash}} {{date}}</span>
  </div>
</footer>
